import { createStore, createEffect, createEvent, combine } from 'effector';
import { $notificationStore } from '../notificationStore';
import { UsersApi, type UserUpdateRequest, type UserResponse } from '@shared/api';
import { ApiUtils } from '@shared/utils';

const updateUserEffect = createEffect((request: UserUpdateRequest) => UsersApi.updateUser(request));
const clearEvent = createEvent();

const $dataStore = createStore<UserResponse | null>(null)
  .on(updateUserEffect.done, (_, data) => data.result.data ?? null)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(updateUserEffect.pending, (_, data) => data)
  .on(updateUserEffect.fail, () => false)
  .on(updateUserEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(updateUserEffect, () => null)
  .on(updateUserEffect.fail, (_, data) => ApiUtils.getApiErrorData(data.error, 'Something went wrong while updating User. Please try again.').message)
  .on(updateUserEffect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((error) => $notificationStore.events.setError(error));

export const $userUpdateStore = {
  events: {
    updateUser: updateUserEffect,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
